import { render, staticRenderFns } from "./MaterialDiscard.vue?vue&type=template&id=49c17894"
import script from "./MaterialDiscard.vue?vue&type=script&lang=js"
export * from "./MaterialDiscard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports